import React from 'react';
import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';

import Comment from '@spa/shared/components/Reviews/Comment';
import Button from '@spa/shared/components/Unisystem/Button';
import StarRating from '@spa/shared/components/Reviews/StarRating';
import { transformGlobalReviews } from '@spa/shared/utils/transformers/reviews';
import { SectionWrapper, Title, Block, ReviewsHeader, ReviewsHeaderElement } from './styles';

const Reviews = ({ bookingReviews, reviews, showMore = false, handleShowMore = () => {} }) => {
  const { t } = useTranslation();

  const { apAverage, apCount, propertyAverage, propertyCount } = transformGlobalReviews(bookingReviews);

  return (
    <SectionWrapper>
      <Title>{t('Reviews')}</Title>
      <Block>
        <ReviewsHeader>
          <ReviewsHeaderElement>
            <h3>
              {t('This place')} <span>({`${propertyCount} ${t('Reviews')}`})</span>
            </h3>
            <StarRating rating={propertyAverage} />
          </ReviewsHeaderElement>
          <ReviewsHeaderElement>
            <h3>
              {t('The service')} <span>({`${apCount} ${t('Reviews')}`})</span>
            </h3>
            <StarRating rating={apAverage} />
          </ReviewsHeaderElement>
        </ReviewsHeader>
        {reviews && reviews.map(review => <Comment key={review.guest.full_name.first} item={review} />)}
        {showMore ? (
          <Button onClick={handleShowMore} isSecondary>
            {t('Read all reviews')}
          </Button>
        ) : null}
      </Block>
    </SectionWrapper>
  );
};

Reviews.propTypes = {
  bookingReviews: PropTypes.object.isRequired,
  reviews: PropTypes.array.isRequired,
  showMore: PropTypes.bool,
  handleShowMore: PropTypes.func
};

export default Reviews;
